const SkeletonCard = () => {
    return (
        <div className="flex h-full w-full animate-pulse flex-col items-center justify-center space-y-2 rounded-r10 bg-black90 p-2">
            <div className="h-[2rem] w-1/4 rounded-r3 bg-black70"></div>
            <div className="flex w-2/4 flex-col items-center space-y-1">
                <div className="h-3 w-full rounded-r3 bg-black70"></div>
                <div className="h-3 w-full rounded-r3 bg-black70"></div>
            </div>
        </div>
    );
};

export default SkeletonCard;
